import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Report from './Report';
import ModalDialog from '../ModalDialog';
import { membersType, reportsType } from '../../types';
import './_styles_/ReportsPopup.css';

ReportsPopup.propTypes = {
    reports: reportsType.isRequired,
    deliveryYears: PropTypes.arrayOf(PropTypes.number),
    members: membersType,
    onCancel: PropTypes.func.isRequired,
    auctionId: PropTypes.number,
};

ReportsPopup.defaultProps = {
    deliveryYears: [],
    members: [],
    auctionId: null,
};

function ReportsPopup(props) {
    const {
        reports,
        deliveryYears,
        members,
        onCancel,
        auctionId,
    } = props;
    const { t } = useTranslation();
    const result = reports.length > 0 ? reports.map((report) => (
        <Report
            key={report.type}
            type={report.type}
            versions={report.versions}
            formats={report.formats}
            requiredFields={report.requiredFields}
            deliveryYears={deliveryYears.slice()}
            members={members}
            auctionId={auctionId}
        />
    )) : t('reports.no-items');
    return (
        <ModalDialog onCancel={onCancel}>
            <div className="reports-popup-dialog" role="dialog" aria-modal>
                <div className="reports-popup-dialog--header">
                    <h4>{t('reports.title')}</h4>
                    <button type="button" className="close-button button-small button-primary-text reports-popup-dialog--close" onClick={onCancel}>
                        <span aria-label={t('button.x')} title={t('button.x')} role="img">
                            <FontAwesomeIcon icon="times" />
                        </span>
                    </button>
                </div>
                {result}
            </div>
        </ModalDialog>
    );
}

export default ReportsPopup;
